import urlsService, { Target } from '@/services/urls-service';
import { ISrcset } from '@/components/Srcset/ISrcset';

export interface IBlogListRequest {
  sectors: string[];
  categories: string[];
  page: number;
}

export interface IBlogListResponse {
  totalCount: number;
  perPage: number;
  page: number;
  items: IBlogListItem[];
  facets: IBlogFacet[];
}

export interface IBlogFacet {
  name: string;
  items: IBlogFacetItem[];
}

export interface IBlogFacetItem {
  name: string;
  count: number;
}

export interface IBlogListItem {
  image: ISrcset;
  title: string;
  subtitle?: string;
  url: string;
  author?: string;
  sectors: string[];
  category: {
    name: string;
    icon?: string;
  };
}

export class BlogService {
  async fetchBlogList(request: IBlogListRequest): Promise<IBlogListResponse> {
    try {
      const url = urlsService.getUrl('/clapi/blog', { target: Target.Sitecore });
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching blog list:', error);
      throw error;
    }
  }
}

const instance = new BlogService();
export default instance;
